export default __webpack_public_path__ + "static/media/Clínica-Alvorada.302326a3.png";